// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1qXhH","left":"StickyBox_left__o-kuN","right":"StickyBox_right__FmOUP"};